import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4da80990"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1));
const _hoisted_2 = {
    key: 0,
    class: "ajuda"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "btn btn-xs btn-default" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "far fa-copy" })
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, " As variáveis precisam estar entre percentuais para que o sistema identifique e traduza o seu significado. "),
    /*#__PURE__*/ _createElementVNode("li", null, " Para estilizar as variáveis (negrito, itálico, etc), deve-se seleciona-la totalmente, inclusive os percentuais. "),
    /*#__PURE__*/ _createElementVNode("li", null, " Caso estilize a variável e ela não seja traduzida corretamente, remova-a totalmente, e faça o procedimento de copiar/colar novamente. ")
], -1));
const _hoisted_7 = { class: "variaveis" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-copy" }, null, -1));
const _hoisted_10 = [
    _hoisted_9
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
            class: "btn btn-default btn-xs btn-block",
            style: { "margin-bottom": "10px" },
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.ajuda()))
        }, [
            _hoisted_1,
            _createTextVNode(" Exibir Ajuda ")
        ]),
        (_ctx.exibirAjuda)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Utilize as variáveis para colocar dados reais no seu modelo. "),
                _hoisted_3,
                _createTextVNode(" Clique no botão "),
                _hoisted_4,
                _createTextVNode(" para copiar a variável correspondente, em seguida cole no seu modelo onde deseja que ela apareça. "),
                _hoisted_5,
                _hoisted_6
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variaveis, (variavel, chave) => {
                return (_openBlock(), _createElementBlock("li", { key: chave }, [
                    _createElementVNode("b", null, _toDisplayString(chave), 1),
                    _createElementVNode("span", {
                        class: "btn btn-xs btn-default",
                        title: "Copiar",
                        id: "copy",
                        onClick: ($event) => (_ctx.copiar(chave, $event))
                    }, _hoisted_10, 8, _hoisted_8),
                    _createElementVNode("div", null, _toDisplayString(variavel), 1)
                ]));
            }), 128))
        ])
    ], 64));
}
